import React from 'react'
import Layout from './Layout'
import styles from './_layout.css'

export default function PrivacyLayout (props) {
  return (
    <Layout
      className={styles.auth}
      showAuth={false}
      showPrivacyHelp={true}
      showMainNav={false}
      showShortcuts={false}
      showMobileNav={false}
      showFooter={false}
      navContainer={false}
      middleContainer={false}
      {...props}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/layout/PrivacyCenterLayout.jsx